module.exports = __webpack_public_path__ + "static/media/petzenpro-5.bf844472.jpg";